import { render } from "./FinnHome.vue?vue&type=template&id=edac2be8&scoped=true"
import script from "./FinnHome.vue?vue&type=script&lang=js"
export * from "./FinnHome.vue?vue&type=script&lang=js"

import "./FinnHome.vue?vue&type=style&index=0&id=edac2be8&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edac2be8"]])

export default __exports__